import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import ACLMain from "./Pages/ACLMain";
import StcDashboard from "./Pages/StcDashboard";
import Challenge66 from "./Pages/Chalenge66";
import Analysis66 from "./Pages/Analysis66";
import Concerns66 from "./Pages/Concerns66";

const router = createBrowserRouter([
  {
    path: "/",
    element: <ACLMain />,
  },
  {
    path: "/stc",
    element: <StcDashboard />,
  },
  {
    path: "/challenge66",
    element: <Challenge66 />,
  },
  {path: "/66",
    element: <Analysis66 />},
    {
    path: "/concerns",
    element: <Concerns66 />
  }
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
